import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ChangeRateRequest, ClientRateAssignmentsApiAdapter } from '../adapters/ClientRateAssignmentsApiAdapter';

export const useChangeRate = (teamId: number) => {
    const queryClient = useQueryClient();

    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientRateAssignmentsApiAdapter(httpClient);
    }, []);

    const mutation = useMutation({
        mutationFn: (request: Omit<ChangeRateRequest, 'team_id'>) =>
            apiAdapter.changeRate({ ...request, team_id: teamId }),
        onSuccess: () => {
            // Invalidar la cache de asignaciones de tarifas
            queryClient.invalidateQueries({ queryKey: ['clientRateAssignments', teamId] });
        },
    });

    return {
        changeRate: mutation.mutate,
        changeRateAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        error: mutation.error,
        reset: mutation.reset,
    };
};

